import { Outlet } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Header } from '../components/header';

// Including components that use React Router hooks here
// Components common to all routes can be included in <App>
export function Root() {
  return (
    <div className="flex flex-column">
      <Header />
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Outlet />
      </QueryParamProvider>
    </div>
  );
}
